import { portalFetch } from '../../shared/auth/portalSession';
import { getAuthHeaders, requireAuthentication } from './authUtils';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

interface WorkingHours {
  startTime: string;
  endTime: string;
}

interface DayWorkingHours {
  dayId: string;
  dayLabel: string;
  isOpen: boolean;
  workingHours: WorkingHours[];
}

interface ScheduleApiResponse {
  schedule: DayWorkingHours[];
  count: number;
}

/**
 * Get the complete schedule for all days
 * @param scheduleType - 1 for Xray, 2 for US
 */
export const getScheduleApi = async (scheduleType: number = 2): Promise<DayWorkingHours[]> => {
  requireAuthentication();
  
  try {
    const response = await portalFetch('admin', `${API_BASE_URL}/schedule?type=${scheduleType}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch schedule: ${response.statusText}`);
    }

    const data: ScheduleApiResponse = await response.json();
    return data.schedule || [];
  } catch (error) {
    console.error('Error fetching schedule:', error);
    throw error;
  }
};

/**
 * Update the complete schedule (batch update for all days)
 * @param schedule - Array of day schedules
 * @param scheduleType - 1 for Xray, 2 for US
 */
export const updateScheduleApi = async (schedule: DayWorkingHours[], scheduleType: number = 2): Promise<DayWorkingHours[]> => {
  requireAuthentication();
  
  try {
    const response = await portalFetch('admin', `${API_BASE_URL}/schedule?type=${scheduleType}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ schedule, scheduleType }),
    });

    if (!response.ok) {
      throw new Error(`Failed to update schedule: ${response.statusText}`);
    }

    const data: ScheduleApiResponse = await response.json();
    return data.schedule || [];
  } catch (error) {
    console.error('Error updating schedule:', error);
    throw error;
  }
};
